import React, { useState } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { Button, Box, Dialog, DialogContent, Stack, Typography, Modal, Tooltip as TT, IconButton, ButtonGroup, Grid, Card, CardHeader, CardContent } from '@mui/material'

import EditIcon from '@mui/icons-material/Edit';

import { selectGlobalSettingEntities } from '../../../reducers/reference_settings';
import { selectViewInstanceById } from '../../../reducers/reuseable_vi';
import { useNavigate, createSearchParams } from 'react-router-dom'
import PreviousAssessmentTable from './PreviousAssessmentTable';
import PreviousAssessmentTableMobile from './PreviousAssessmentTableMobile';

const ProfilePreviousAssessmentCard = ( props) => {
    
    return (
        <Card elevation={0}>
            <CardHeader
           
            />
            
            <CardContent>
            <Box display={{xs:"none", sm:"none", md:"block"}} >
                    <PreviousAssessmentTable/>
                </Box>
                <Box display={{xs:"block", sm:"block", md:"none"}}>
                    <PreviousAssessmentTableMobile/>
                </Box>
            </CardContent>
        </Card>

    )

}

export default ProfilePreviousAssessmentCard